var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 279,
    viewBox: "0 0 236 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M129.477 100.753C129.477 100.753 207.231 174.656 223.972 220.693L235.149 223.828L210.349 244.934L150.198 190.376C150.198 190.376 109.071 171.591 100.614 146.792C92.1572 121.993 90.812 107.746 90.812 107.746",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.614 146.792C105.132 160.039 118.971 171.569 130.885 179.438C132.799 171.652 133.746 163.66 133.704 155.642C133.704 128.037 123.22 105.658 110.289 105.658C103.586 105.658 97.5412 111.672 93.2729 121.308C95.2787 129.924 97.7289 138.43 100.614 146.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "theme",
    d: "M120.089 103.06C120.089 103.06 127.191 218.967 107.134 273.845L111.323 280H75.6493C75.6493 280 71.752 132.573 71.752 100.753L120.089 103.06Z",
    fill: "#5100CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 13.3817V28.4449L89.5825 33.031V7.61106L108.243 3.0249V13.3817Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7021 18.5933C97.9776 18.5933 98.201 18.3699 98.201 18.0944C98.201 17.8188 97.9776 17.5955 97.7021 17.5955C97.4265 17.5955 97.2031 17.8188 97.2031 18.0944C97.2031 18.3699 97.4265 18.5933 97.7021 18.5933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.366 18.5933C105.641 18.5933 105.865 18.3699 105.865 18.0944C105.865 17.8188 105.641 17.5955 105.366 17.5955C105.09 17.5955 104.867 17.8188 104.867 18.0944C104.867 18.3699 105.09 18.5933 105.366 18.5933Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.117 21.0706V13.3817H106.969",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7622 13.3817H100.614",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8121 17.3214V19.9915C90.1204 19.9915 89.457 19.7167 88.968 19.2276C88.4789 18.7386 88.2041 18.0752 88.2041 17.3835C88.2041 17.3035 88.2077 17.2244 88.2148 17.1462C88.3609 15.5267 90.8121 15.6953 90.8121 17.3214Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8121 19.9915C90.1204 19.9915 89.457 19.7167 88.968 19.2276C88.4789 18.7386 88.2041 18.0752 88.2041 17.3835",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.433 22.9662C100.732 22.9662 100.061 22.6881 99.5661 22.1931C99.0711 21.6981 98.793 21.0267 98.793 20.3267",
    stroke: "#FF6498",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.243 28.4447L89.583 33.0311",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.117 21.0768L101.433 21.4909",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.476 60.0051V100.753L71.752 114.941V69.5587C71.752 61.7394 74.3737 54.1458 79.1981 47.9922C84.0224 41.8385 90.7708 37.4801 98.3641 35.6137H98.3642C102.063 34.7047 105.919 34.6487 109.643 35.4499C113.366 36.251 116.859 37.8885 119.856 40.2383C122.853 42.5881 125.277 45.5887 126.944 49.0133C128.61 52.4378 129.476 56.1965 129.476 60.0051L129.476 60.0051Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.089 103.06C120.089 103.06 127.19 218.967 107.133 273.844",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.812 17.3214C90.812 17.3214 92.9814 13.0416 91.926 9.87559L94.1246 12.6019C94.1246 12.6019 104.5 10.3153 105.864 5.56628L108.243 8.11669L108.724 6.88546",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1113 16.0133C89.1113 16.0133 83.4828 7.67691 90.0787 2.22432C96.6746 -3.22827 111.098 4.42295 111.098 4.42295C111.098 4.42295 108.917 12.1227 108.243 12.1227",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8738 40.7726C86.8738 40.7726 44.1717 67.3036 15.3257 106.351C-13.5202 145.399 7.93835 127.458 7.93835 127.458C7.93835 127.458 19.8989 128.865 20.9542 120.422C20.9542 120.422 78.7047 79.9676 90.8119 81.023",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.969 34.8757C106.969 34.8757 172.725 31.7261 199.062 37.8714C227.204 44.4379 205.394 47.3701 205.394 47.3701C205.394 47.3701 203.049 54.6402 195.075 49.8214C195.075 49.8214 146.882 57.4192 129.476 65.0757",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople3);
export default __webpack_public_path__ + "static/media/people-3.84135446d7c6881041b1a6b12ec79023.svg";
export { ForwardRef as ReactComponent };